import { JSONSchema7 } from 'json-schema';
import JSONSchema7Properties from '../../../Shared/jSONSchema7Properties';
import { GridSize } from '../../../Shared/Enums/gridSize';

export default (currVer: JSONSchema7): JSONSchema7 => {
  let properties = currVer.properties as JSONSchema7Properties;

  properties['version'].default = 2;

  properties = {
    ...properties,
    gridSize: {
      $id: `${currVer.$id}/gridSize`,
      default: GridSize.FULL,
      type: 'number'
    }
  };
  return {
    ...currVer,
    properties
  };
};
